import { useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import { resourcesBaseUri } from "../../config";
import './Header.scss';

const Header = () => {
	const navigate = useNavigate();
	const navigateToHome = useCallback(() => {
		navigate('/');
	}, [navigate]);

	return (
		<div className="header">
			<img
				className="header__logo"
				src={`${resourcesBaseUri}/rblogo-trans.png`}
				alt="Ritchie Bros logo"
				onClick={navigateToHome}
			/>
		</div>
	);
}

export default Header;